import { get as getJson } from 'api'

export const getList = async request => getJson('/VatDeduction/getList', request)
export const get = async id => getJson(`/VatDeduction/get/${id}`)
